<template>
    <v-autocomplete
        dense
        outlined
        v-bind="$attrs"
        :items="items"
        item-text="rubric"
        item-value="id"
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'EvenfrogRubricSelect',

    computed: {
        ...mapState('eventfrog_rubric', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            // here we could filter the models, if needed
            return this.collection ? this.collection.models : [];
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('eventfrog_rubric', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
